import React, { useState } from 'react';
import './Navbar.scss';
// import { images } from '../../constants';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <>
      {/* <div className="app__navbar-logo absolute">
        <img src={images.logo} alt="logo" />
      </div> */}
      <nav className="app__navbar">
        <ul className="app__navbar-links">
          {['home', 'about', 'work', 'skills', 'testimonial', 'contact'].map(
            (item) => (
              <li className="app__flex p-text" key={`link-${item}`}>
                <div />
                <a href={`#${item}`}>{item}</a>
              </li>
            )
          )}
        </ul>

        <div className="app__navbar-menu">
          <HiMenuAlt4 onClick={() => setToggle(true)} />

          {toggle && (
            <motion.div
              whileInView={{ x: [300, 0] }}
              transition={{ durationn: 0.85, ease: 'easeInOut' }}
            >
              <ul>
                <HiX onClick={() => setToggle(false)} />
                {[
                  'home',
                  'about',
                  'work',
                  'skills',
                  'testimonial',
                  'contact',
                ].map((item) => (
                  <li key={item}>
                    <a href={`#${item}`} onClick={() => setToggle(false)}>
                      {item}
                    </a>
                  </li>
                ))}
              </ul>

              {/* <motion.div>
                <SocialMedia className="app__social" />
              </motion.div> */}
            </motion.div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
